module.exports = __webpack_public_path__ + "static/media/m10cr538.50b5d83d.png";